





















































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbTooltipSlot } from 'bag-of-holding-library';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import DateFormat from 'bag-of-holding-library/src/utils/date-format';
import moment from 'moment';
import SelectionComponent from '@/shared/fields/selection.componet.vue';
import SelectiveProcessFilter from '@/domain/selective-process/selective-process-filter.entity';
import SelectiveProcessService from '@/domain/selective-process/service/selective-process.service';
import Loading from '@/shared/loading/loading.component.vue';

@Component({
  components: {
    LabelSlot,
    SelectionComponent,
    VbTooltipSlot,
    Loading,
  },
})
export default class SelectiveProcessFilterComponent extends Vue {
  @Prop() filter!: SelectiveProcessFilter;

  numericalReasoningGradePeriodMenu: boolean = false;

  verbalReasoningGradePeriodMenu: boolean = false;

  cultureGradePeriodMenu: boolean = false;

  locale = 'pt-BR';

  isFilterCandidateEmail: boolean = false;

  isFilterJobExternalId: boolean = false;

  jobStatus: string[] = []

  showMoreFilters: boolean = false;

  loadingStatus: boolean = false;

  created() {
    this.getStatus();
  }

  getStatus() {
    this.loadingStatus = true;
    SelectiveProcessService.getAllStatus()
      .then((response) => {
        this.jobStatus = response;
      })
      .finally(() => {
        this.loadingStatus = false;
      });
  }

  datePeriodFormat(dates: string[]) {
    return dates.map((el: string) => DateFormat.timestampToLocal(el));
  }

  setReasoningGradePeriod(field: string) {
    const initialDateIsBefore = moment(this.filter[field][1])
      .isBefore(this.filter[field][0]);
    if (initialDateIsBefore) {
      this.filter[field].reverse();
    }
  }

  setCultureGradePeriod() {
    const initialDateIsBefore = moment(this.filter.cultureGradePeriod[1])
      .isBefore(this.filter.cultureGradePeriod[0]);
    if (initialDateIsBefore) {
      this.filter.cultureGradePeriod.reverse();
    }
  }

  get numericalReasoningPeriodText() {
    return this.datePeriodFormat(this.filter.numericalReasoningGradePeriod).join(' ~ ');
  }

  get verbalReasoningPeriodText() {
    return this.datePeriodFormat(this.filter.verbalReasoningGradePeriod).join(' ~ ');
  }

  get cultureGradePeriodText() {
    return this.datePeriodFormat(this.filter.cultureGradePeriod).join(' ~ ');
  }

  clearReasoningGradePeriod(field: string) {
    this.filter[field] = [];
    this.sendFilter();
  }

  clearCultureGradePeriod() {
    this.filter.cultureGradePeriod = [];
    this.sendFilter();
  }

  clearFilter() {
    this.filter = new SelectiveProcessFilter();
    this.sendFilter();
  }

  sendFilter() {
    this.$emit('sendFilter', this.filter);
  }

  changeCandidateFilterFormat() {
    if (this.filter.candidateName) {
      this.filter.candidatesEmails = this.filter.candidateName;
      this.filter.candidateName = '';
    } else if (this.filter.candidatesEmails) {
      this.filter.candidateName = this.filter.candidatesEmails;
      this.filter.candidatesEmails = '';
    }
    this.isFilterCandidateEmail = !this.isFilterCandidateEmail;
  }

  get candateFilterField() {
    return this.isFilterCandidateEmail ? 'candidatesEmails' : 'candidateName';
  }

  get jobFilterField() {
    return this.isFilterJobExternalId ? 'jobsExternalId' : 'jobName';
  }

  get candateFilterInputPlaceholder() {
    return this.isFilterCandidateEmail ? 'Digite o e-mail do candidato...' : 'Digite o nome do candidato...';
  }

  get candidateFilterInputHint() {
    return this.isFilterCandidateEmail ? 'Utilize virgula para filtrar mais de um candidato por email' : '';
  }

  get jobFilterInputPlaceholder() {
    return this.isFilterJobExternalId ? 'Digite o id da vaga...' : 'Digite o nome da vaga';
  }

  get jobFilterInputHint() {
    return this.isFilterJobExternalId ? 'Utilize vigula para filtrar mais de uma vaga por id' : '';
  }
}
